var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScythe1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43999 19.513L15.3104 7.03098L18.3738 4.05998L19.4356 3.03023C20.0222 2.46128 20.9734 2.46128 21.56 3.03023C22.1467 3.59918 22.1467 4.52163 21.56 5.09058L20.4982 6.12032L17.3037 9.21851L4.56444 21.5734C3.97779 22.1423 3.02664 22.1423 2.43999 21.5734C1.85334 21.0044 1.85334 20.082 2.43999 19.513Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C9.53412 2 7.26448 2.81489 5.46179 4.18215C6.03592 4.10189 6.62295 4.06035 7.21999 4.06035C10.3229 4.06035 13.1557 5.18238 15.3104 7.03092L18.3738 4.05992C16.5984 2.76646 14.3915 2 12 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScythe1);
export default __webpack_public_path__ + "static/media/scythe-1.f4bd98bfa106b72b7b52896fb3ead575.svg";
export { ForwardRef as ReactComponent };